import React, { useMemo } from 'react';
import styled from 'styled-components';
import { withTheme } from '../../../../theme';
import { formatDuration } from '../../../../util/duration';
import { useCurrentTime } from '@/util/timerHooks';

const Timer = styled.div`
  display: flex;
  justify-content: left;
  align-items: flex-start;
  font-size: 1em;
  font-family: monospace;
  font-weight: 500;
  opacity: 0.75;
  color: ${withTheme(theme => theme.textColor.string())};
`;

const OrRoomReadyTime = props => {
  const orRoomReadyDefault = useMemo(() => new Date(), []);

  return (
    <Timer>
      OR Prep Time:{' '}
      <DurationBetween
        since={props?.room?.turnoverStartedAt || orRoomReadyDefault}
        until={props?.room?.orRoomReady ? props?.room?.orRoomReadyAt : undefined}
      />
    </Timer>
  );
};

export default OrRoomReadyTime;

export const DurationBetween = ({ since, until }) => {
  if (until) {
    return <>{formatDuration(since, until, true)}</>;
  } else {
    return <Duration since={since} />;
  }
};

const Duration = ({ since }) => {
  // Use the proper useCurrentTime hook for duration calculations
  const currentTime = useCurrentTime({
    interval: 60 * 1000, // Update every minute
    precision: 'minute',
    batteryOptimized: true,
  });
  return <>{formatDuration(since, currentTime, true)}</>;
};
